module.exports = __webpack_public_path__ + "img/CS26Q-中_15.3fefd320.jpg";